import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import { Button, InputAdornment, Icon, TextField, Grid, Typography } from '@material-ui/core';

import { withTheme } from '@material-ui/core/styles';

import cuhk_clst from "../images/logos/cuhk_clst.png";

const styles = {
  inputAdornmentIconPointer: {
    cursor: "pointer"
  },
  logo:{
    width:'100%',
    padding: 0
  }
};

class LoginDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      username: "",
      password: "",
      passwordIsMasked: true,
    };
    autoBind(this);
  }

  usernameChanged (e) {
      this.setState({
        username: e.target.value
      });
      this.state.username = e.target.value;
  }
  passwordChanged (e) {
      this.setState({
        password: e.target.value
      });
      this.state.password = e.target.value;
      if (e.target.value.length == 0) {
        this.setState({passwordIsMasked:true});
        this.state.passwordIsMasked = true;
      }
  }

  togglePasswordMask() {
    var masked = !this.state.passwordIsMasked;
    this.setState({passwordIsMasked: masked})
    this.state.passwordIsMasked = masked;
  }

  loginClicked() {
    let requestObj = {
      username: this.state.username,
      password: this.state.password,
    }
    this.props.root.refs.API.request("user_login", requestObj, this.loginOK, this.loginFailed);
  }

  loginOK(res) {
    if (res.body['result']['id'] > 0) {
      //console.log("login ok");
      this.props.parent.loginOK(res.body['result']);
    } else {
      this.loginFailed();
    }
  }

  loginFailed(res) {
    console.log("login failed");
    this.props.root.addNotification("Username / Password Incorrect");
  }

  handleEnterPressed(e) {
    if (e.key === "Enter") {
      this.loginClicked();
    }
  }

  render() {
    return (
      <div>
        <Dialog
          open={true}
          fullWidth={true}
          maxWidth={'xs'}
          BackdropProps={{
            invisible: true
          }}
        >
          <DialogTitle>
            <div style={{textAlign: 'center', fontWeight: 'bold'}}>EduVenture-VR® Composer</div>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} style={{padding: '25px 0'}}>
              <Grid item xs={12}>
                <TextField
                  label="Username/Email"
                  value={this.state.username}
                  onChange={this.usernameChanged}
                  onKeyPress={this.handleEnterPressed}
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><Icon>email</Icon></InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Password"
                  value={this.state.password}
                  type={this.state.passwordIsMasked? "password" : "text"}
                  onChange={this.passwordChanged}
                  onKeyPress={this.handleEnterPressed}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <If condition={this.state.password.length > 0}>
                          <Then>
                            <Icon onClick={this.togglePasswordMask} style={this.props.theme.customStyles.inputAdornmentIconPointer}>
                              { this.state.passwordIsMasked? "visibility_off" : "visibility" }
                            </Icon>
                          </Then>
                          <Else>
                            <Icon>
                              lock_outline
                            </Icon>
                          </Else>
                        </If>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid container item xs={12} spacing={2} justifyContent="center">
                <Grid item xs={10} sm={8} md={6}>
                  <img style={this.props.theme.customStyles.logo} src={cuhk_clst}/>
                </Grid>
              </Grid>
              <Grid item xs={12} style={{textAlign: 'center'}}>
                <Typography variant="caption" style={{color: this.props.theme.palette.muted.main}}>
                  Version 20250506 Copyright © 2025. All Rights Reserved <br/>
                  Centre for Learning Sciences and Technologies <br/>
                  The Chinese University of Hong Kong
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.props.parent.forgetPasswordClicked}>Forgot Password</Button>
            <Button color="primary" variant="contained" onClick={this.loginClicked}>Login</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withTheme(LoginDialog);
